export default {
  container: {
    display: ({ filterValues }) =>
      filterValues.length ? "flex" : "none!important",
    height: "fit-content",
    flexDirection: "row",
    flexWrap: "wrap",
  },
};
